import isUndefined from 'lodash/isUndefined';
import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';

import {ClauseType} from './types';

const FORMULA_OPERATORS = [`+`, `-`, `*`, `/`, `(`, `)`];
export class FormulaClause {
  static TYPE: typeof ClauseType.Formula = ClauseType.Formula;

  declare dataset: string;
  declare errorMessage: string;
  declare label: string;
  declare value: string;

  constructor(attrs: any = {}) {
    this.dataset = attrs.dataset;
    this.value = attrs.value;
    if (attrs.label) {
      this.label = attrs.label;
    }
    if (attrs.errorMessage) {
      this.errorMessage = attrs.errorMessage;
    }
  }

  extend(attrs = {}) {
    return new FormulaClause({...this.attrs, ...attrs});
  }

  get attrs() {
    return {
      ...pick(this, [`dataset`, `label`, `value`, `errorMessage`]),
    };
  }

  get valid() {
    return !!this.value;
  }

  toBookmarkData() {
    return pickBy(this.attrs, (value) => !isUndefined(value));
  }

  toUrlData() {
    return this.attrs;
  }

  serialize() {
    return this.toBookmarkData();
  }

  trackingData() {
    if (!this.valid) {
      return {};
    }
    const {label, value} = this;
    const operatorRegex = new RegExp(FORMULA_OPERATORS.map((op) => `\\${op}`).join(`|`), `g`);
    return {
      '# of clauses': value
        .replace(/\s/g, ``)
        .split(operatorRegex)
        .filter((operand) => operand !== ``).length,
      operators: value.match(operatorRegex) || [],
      named: !!label,
      ...this.attrs,
    };
  }
}
